<template>
  <div class="relative" data-test-id="vf-video">
    <base-video
      ref="videoRef"
      v-style="directives?.['v-style']"
      class="full cover"
      v-bind="{ ...$props }"
      :controls="false"
      @ended="$emit('ended', $event)"
      @pause="$emit('pause', $event)"
      @play="$emit('play', $event)"
      @playing="$emit('playing', $event)"
    />
    <client-only>
      <vf-video-controls
        v-if="controls"
        class="absolute right-0 z-1 c-white duration"
        :class="[brandClasses?.control?.wrapper, classControls]"
        :paused="videoRef?.paused"
        :progress="videoRef?.progress"
        :size="controlsSize || defaultControlsSize"
        :style="styleControls"
        @click="videoRef?.toggle"
      />
    </client-only>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import type { CSSClass, Responsive } from '#types/common'
import type { BaseVideo as BaseVideoProps } from '#types/components/base/video'
import type { IconSizes } from '#types/sizes'
import type { StyleValue } from 'vue'

interface VfVideoProps extends BaseVideoProps {
  controls?: boolean
  classControls?: CSSClass
  controlsSize?: IconSizes | Partial<Responsive<IconSizes>>
  styleControls?: StyleValue
  directives?: Record<string, any>
}

interface VfVideoRef extends HTMLVideoElement {
  paused: boolean
  progress: number
  toggle: () => void
}

const { controls = true } = defineProps<VfVideoProps>()

defineEmits<{
  ended: [e: Event]
  pause: [e: Event]
  play: [e: Event]
  playing: [e: Event]
}>()

const { brandClasses, controlsSize: defaultControlsSize } = useAppConfig().components.vf.video

const videoRef = ref<VfVideoRef>()

defineExpose({
  videoRef,
  play: () => videoRef.value?.play().catch((e) => log.error(e)),
  pause: () => videoRef.value?.pause(),
  load: () => videoRef.value?.load()
})
</script>
